// The static parts of an icon entry, as IconEditor's defaultIconObject and the icons a design
// stores carry them: the default Iconify collection, the style, the active states and the
// colour-list references of a new icon, and every setting the editor applies across a
// selection. The position depends on the selection, so it stays in IconEditor. Also the icon
// entry a predefined legend's icon is merged over in TextEditor (defaultLegendIconObject).
export const defaultCollection = {
  name: 'formkit',
  author: {
    name: 'FormKit, Inc',
    url: 'https://github.com/formkit/formkit/tree/master/packages/icons', // a url to the icons of this collection (icon set)
  },
  license: {
    spdx: 'MIT',
    title: 'MIT',
    url: 'https://github.com/formkit/formkit/blob/master/packages/icons/LICENSE', // a url to the license of this collection (icon set)
  },
};
export const defaultStyle = {
  width: 10,
  height: 10,
  originalAspectRatio: 1,
  fill: '#000000',
  stroke: '#000000',
  strokeWidth: 0.5,
  flip: 'none', // Type: "horizontal" | "vertical" | "horizontal vertical" (Flip the icon horizontally, vertically, or both. This is helpful for mirroring icons.)
};
export const defaultIsActiveStates = {
  fill: false,
  stroke: false,
  preserveAspectRatio: true,
};
export const defaultSelectedIconColorIndexes = {
  fill: null,
  stroke: null,
};

export const defaultLegendIconObject = {
  source: 'iconify',
  icon: null,
  iconCollection: {
    name: null,
    author: {
      name: null,
      url: null,
    },
    license: {
      spdx: null,
      title: null,
      url: null,
    },
  },
  assetId: null,
  format: null,
  style: {
    width: 5,
    height: 5,
    originalAspectRatio: 1,
    fill: '#000000',
    stroke: '#000000',
    strokeWidth: 0.5,
    flip: 'none',
  },
  position: {
    isoSection: 'none',
    gridStructure: '3x3',
    gridRow: 2,
    gridColumn: 2,
    cellAlignment: 'center',
    boundingBox: 'compact',
    rotation: 0,
    xOffset: 0,
    yOffset: 0,
  },
  isActiveStates: defaultIsActiveStates,
  selectedIconColorIndexes: defaultSelectedIconColorIndexes,
  tagId: null,
  visible: true,
}; // the icon entry a predefined legend's icon is merged over in TextEditor (its legend assignment): an older copy of IconEditor's defaultIconObject, 5 mm and without a default icon or collection, kept as is (user decision, Oct 2026)

export const ICON_FIELD_PATHS = [
  'style.width',
  'style.height',
  'style.originalAspectRatio',
  'style.fill',
  'style.stroke',
  'style.strokeWidth',
  'style.flip',
  'position.isoSection',
  'position.gridStructure',
  'position.gridRow',
  'position.gridColumn',
  'position.cellAlignment',
  'position.boundingBox',
  'position.rotation',
  'position.xOffset',
  'position.yOffset',
  'isActiveStates.fill',
  'isActiveStates.stroke',
  'isActiveStates.preserveAspectRatio',
  'selectedIconColorIndexes.fill',
  'selectedIconColorIndexes.stroke',
]; // all possible paths (settings) of an icon entry (excludes: 'icon' (the content itself), 'iconCollection' (metadata), 'tagId', and 'visible')
